module.exports = __webpack_public_path__ + "img/Closeup Emperador-02.4741ee27.png";